<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('contract_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-gavel</v-icon>{{ item['ref'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-contract-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('contract.ref') }}</strong></td>
              <td>
                                    {{ item['ref'] }}
              </td>
              <td></td>
              <td>

              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.start') }}</strong></td>
              <td>
                                    {{ formatDate(item['start'])  }}
              </td>
              <td><strong>{{ $t('contract.end') }}</strong></td>
              <td>
                                    {{ formatDate(item['end'])  }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.timeinit') }}</strong></td>
              <td>
                                    {{ item['timeInit']  }}
              </td>
              <td><strong>{{ $t('contract.timeused') }}</strong></td>
              <td>
                                    {{ item['timeUsed']  }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.type') }}</strong></td>
              <td>
                  <span  v-if="item['type']"><router-link class="routerLink text-decoration-underline" :to="{ name: 'ContracttypeShow', params: { id:  item['type']['@id']}  }">{{ item['type'].name }}</router-link></span>
              </td>

              <td><strong>{{ $t('contract.customer') }}</strong></td>
              <td>
                  <span  v-if="item['customer']"><router-link class="routerLink text-decoration-underline" :to="{ name: 'CustomerShow', params: { id:  item['customer']['@id']}  }">{{ item['customer'].name }}</router-link></span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('contract.products') }}</strong></td>
              <td>
                <ul v-for="(object, attr) in item['products']" :key="attr">
                  <li>
                    <span ><router-link class="routerLink" :to="{ name: 'ProductShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('contract.enable') }}</strong></td>
              <td>
                <span v-if="item.valid" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else-if="item.valid == null" class="mr-2"><v-icon color="gray">mdi-help-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.comment') }}</strong></td>
              <td colspan="3">
                  {{ item['comment'] }}
              </td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';


const servicePrefix = 'Contract';

export default {
  name: 'ContractShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('contract', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('contract', ['find']),

  },
  methods: {
    ...mapActions('contract', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
